import React, { useContext, useRef } from 'react'
import { ThemeContext } from 'styled-components'
import { useTranslation } from 'react-i18next'

import { Icon } from '@navent-jobs/ui-kit/components/icon'
import Text from '@navent-jobs/ui-kit/components/text'
import { Tooltip } from '@navent-jobs/ui-kit/components/tooltip'
import { IconWrapper } from './mixins'

const EmpresaVerificada = ({ iconSize = "24", marginLeft = "8px", showMobile = false }) => {
  const { t } = useTranslation()
  const { colors } = useContext<{ colors }>(ThemeContext)
  const tooltipRef = useRef<HTMLDivElement>(null)

  return (
    <>
      <IconWrapper className="company-verified" marginLeft={marginLeft} ref={tooltipRef}>
        <Icon name="icon-bold-verified" size={iconSize} color={colors.info.normal} />
      </IconWrapper>
      <Tooltip
        background={colors.extra.normal}
        color={colors.extra.normal}
        toggleElement={tooltipRef}
        position="right"
        align="center"
        width="100%"
        showMobile={showMobile}
        hideTransition
      >
        <Text size="xs" variant="gray0">
          {t('companySummary.verificada.text')}
        </Text>
      </Tooltip>
    </>
  )
}

export default EmpresaVerificada
